import { useRef } from 'react';
import {
    ApplicantContainer,
    ApplicationDataStore,
    CoApplicantContainer,
    DisclosureDataStore,
    DisclosuresContainer,
    MailingAddressContainer,
    PrequalsDisclosuresContainer,
    ImperativeForm,
} from '@servicetitan/financing-application-shared';
import { SetupDataStore, WorkflowStore } from '@servicetitan/financing-workflow-shared';
import {
    ApplicationButtons,
    StepperLayout,
    FooterDisclosures,
} from '@servicetitan/financing-application-workflow-shared';
import { isBlank } from '@servicetitan/financing-utils-shared';

export function PrequalificationWorkflow() {
    const { setWorkflowStage } = WorkflowStore.useStore();
    const formRef = useRef<ImperativeForm>(null);
    const { setupData } = SetupDataStore.useStore();
    const { disclosureState } = DisclosureDataStore.useStore();
    const { applicationData } = ApplicationDataStore.useStore();
    const isApplyingForPrequalification = setupData?.isApplyingForPrequalification;
    const hasTransitionedToHardApp = setupData?.hasTransitionedToHardApp;
    const hasEnteredAddress =
        !isBlank(applicationData.applicant.primaryApplicant?.jobDetails.address?.city) &&
        !isBlank(applicationData.applicant.primaryApplicant?.jobDetails.address?.state) &&
        !isBlank(applicationData.applicant.primaryApplicant?.jobDetails.address?.zip) &&
        !isBlank(applicationData.applicant.primaryApplicant?.jobDetails.address?.street);

    const steps = [
        {
            name: 'applicant',
            label: 'Applicant',
            panelComponent: <ApplicantContainer formRef={formRef} />,
            buttonsComponent: <ApplicationButtons formRef={formRef} showBackToPlanSelection />,
        },
        hasTransitionedToHardApp && hasEnteredAddress
            ? null
            : {
                  name: 'mailing-address',
                  label: 'Mailing Address',
                  panelComponent: <MailingAddressContainer formRef={formRef} />,
              },
        {
            name: 'co-applicant',
            label: 'Co-applicant',
            panelComponent: <CoApplicantContainer formRef={formRef} />,
        },
        {
            name: 'disclosures',
            label: 'Disclosures',
            panelComponent: isApplyingForPrequalification ? (
                <PrequalsDisclosuresContainer />
            ) : (
                <DisclosuresContainer />
            ),
            buttonsComponent: (
                <ApplicationButtons
                    formRef={formRef}
                    isNextButtonDisabled={!disclosureState.agreedToDisclosures}
                />
            ),
        },
    ].filter((step): step is NonNullable<typeof step> => step !== null);

    return (
        <StepperLayout
            onComplete={() => setWorkflowStage('reviewing')}
            buttonsComponent={<ApplicationButtons formRef={formRef} />}
            footerComponent={<FooterDisclosures />}
            steps={steps}
        />
    );
}
